import styled from 'styled-components';
import PropTypes from 'prop-types';

export const InputFieldProps = {
  switchOffBrowserAutocomplete: PropTypes.bool,
  fieldSuffix: PropTypes.any,
  isValid: PropTypes.bool,
  id: PropTypes.string.isRequired,
};

export const InputField = styled.input.attrs({
  'aria-invalid': (props) => (props.isValid !== false ? 'false' : 'true'),
  autocomplete: (props) => (props.switchOffBrowserAutocomplete ? 'off' : 'on'),
})`
  border: 1px solid
    ${(props) =>
      props.isValid !== false
        ? props.theme.borderColor
        : props.theme.errorColor};
  border-radius: 2px;
  padding: 0.844rem
    ${(props) => suffixLengthInRem(props.fieldSuffix) + 1.125}rem 0.844rem
    1.125rem;
  font-size: 1rem;
  color: ${(props) => props.theme.textColor};
  width: 100%;

  &:focus {
    border: 1px solid ${(props) => props.theme.actionColor};
    outline: 0;
  }

  &::-webkit-input-placeholder {
    color: ${(props) => props.theme.textSecondaryColor};
  }
  &::-moz-placeholder {
    opacity: 1;
    color: ${(props) => props.theme.textSecondaryColor};
  }
  &:-ms-input-placeholder {
    color: ${(props) => props.theme.textSecondaryColor};
  }
`;

InputField.propTypes = {
  ...InputFieldProps,
};

const suffixLengthInRem = (suffix) => (suffix ? 0.5 + suffix.length * 0.6 : 0);
